import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    // Session check in progress
    return (
      <div className="min-h-screen grid place-items-center text-sm text-zinc-400">
        Checking session…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (user.mfa_status === "enrollment_required" && location.pathname !== "/enroll-2fa") {
    return <Navigate to="/enroll-2fa" replace />;
  }
  return children;
}
